import React, { useEffect, useState } from "react";
import { Button, Col, Row, FormControl } from "react-bootstrap";
import Select from "react-select";
import { warehouseInventoryDispatchStatus } from "./warehouseInventoryDispatchUtils";
import DateRangePicker from "react-daterange-picker";

const WarehouseInventoryFilter = (props) => {
  const [filter, setFilter] = useState("");
  const {
    setFilterByUser,
    filterByUser,
    filterByStatus,
    setFilterByStatus,
    filterByStore,
    setFilterByStore,
    getAllStores,
    setfilterByWarehouseDispatchId,
    filterByWarehouseDispatchId,
    handleNavigateToAddWarehouseInventoryDispatch,
    isDateRangePickerOpen,
    onToggle,
    selecttedRange,
    setSelecttedRange,
  } = props;

  useEffect(() => {}, []);
  return (
    <>
      <div
        className="warehouse-inventory-filter"
        style={{
          margin: "10px",
          padding: "10px",
          border: "1px dashed grey",
          borderRadius: "10px",
        }}
      >
        <Row>
          <Col md={2}>
            <FormControl
              name="warehouseDispatchId"
              onChange={(e) => {
                setfilterByWarehouseDispatchId(e.target.value);
              }}
              value={filterByWarehouseDispatchId}
              placeholder="Filter By ID"
              style={{ marginTop: "1px" }}
            />
          </Col>
          <Col md={2}>
            <Select
              options={getAllStores}
              isClearable
              onChange={(selectedOption) => {
                setFilterByStore(selectedOption ? selectedOption : "");
              }}
              placeholder="Select Store"
              value={filterByStore}
            />
          </Col>
          <Col md={2}>
            <Select
              options={warehouseInventoryDispatchStatus}
              isClearable
              onChange={(selectedOption) => {
                setFilterByStatus(selectedOption ? selectedOption : "");
              }}
              placeholder="Select Status"
              value={filterByStatus}
            />
          </Col>
          <Col md={2} style={{ display: "flex" }}>
            <Button
              value="Toggle date picker"
              className="fl_mb_web_1 btn-fill fl_mb_1 w_150"
              style={{
                backgroundColor: "white",
                color: "black",
                marginTop: "3px",
              }}
              onClick={() => {
                onToggle();
              }}
            >
              Date Range
            </Button>
            {isDateRangePickerOpen && (
              <DateRangePicker
                value={selecttedRange}
                onSelect={(date) => setSelecttedRange(date)}
              />
            )}
          </Col>
          <Col md={4} style={{ textAlign: "right" }}>
            <Button
              variant="primary"
              style={{
                marginTop: "2px",
                backgroundColor: "black",
                color: "white",
                display: "none",
              }}
              onClick={() => {
                handleNavigateToAddWarehouseInventoryDispatch();
              }}
            >
              ADD NEW DISPATCH
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default WarehouseInventoryFilter;
